<div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
  <!--begin::Signin-->
  <div class="login-form login-signin">
    <div class="text-center mb-10 mb-lg-20">
      <h3 class="font-size-h1">{{ 'AUTH.RESET.TITLE' | translate }}</h3>
      <p class="text-muted font-weight-bold">{{ 'AUTH.RESET.DESC' | translate }}</p>
    </div>

    <kt-auth-notice></kt-auth-notice>

    <!--begin::Form-->
    <form
      class="form"
      [formGroup]="resetPasswordForm"
      autocomplete="off"
      novalidate="novalidate"
      id="kt_login_form"
    >
      <div class="form-group">
        <!-- {{ 'AUTH.INPUT.EMAIL' | translate }} -->

        <mat-form-field appearance="fill">
          <mat-label>{{ 'AUTH.INPUT.PASSWORD' | translate }}</mat-label>

          <input
            matInput
            [type]="!hide ? 'password' : 'text'"
            id="password"
            autocomplete="off"
            placeholder="Password"
            formControlName="password"
          />
          <mat-icon matSuffix (click)="hide = !hide">{{
            hide ? 'visibility' : 'visibility_off'
          }}</mat-icon>

          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'minlength')">
            <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 8</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'maxlength')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'pattern')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} pattern</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field appearance="fill">
          <mat-label>Confirm {{ 'AUTH.INPUT.PASSWORD' | translate }}</mat-label>

          <input
            matInput
            [type]="!hide3 ? 'password' : 'text'"
            id="confirmPassword"
            autocomplete="off"
            placeholder="Confirm password"
            formControlName="confirmPassword"
          />
          <mat-icon matSuffix (click)="hide3 = !hide3">{{
            hide3 ? 'visibility' : 'visibility_off'
          }}</mat-icon>
          <mat-error *ngIf="isControlHasError('confirmPassword', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>

          <mat-error *ngIf="f.confirmPassword.invalid">
            <strong>{{ 'AUTH.VALIDATION.NOT_MATCH' | translate }} </strong>
          </mat-error>
        </mat-form-field>
      </div>
      <!--begin::Action-->
      <div class="form-group d-flex flex-wrap justify-content-center align-items-center">
        <div class="text-dark-50 text-hover-primary my-3 mr-2"></div>
        <button
          id="kt_login_signin_submit"
          (click)="submit()"
          [ngClass]="{
            'spinner spinner-right spinner-md spinner-light': loading
          }"
          class="btn btn-success font-weight-bold px-9 py-4 my-3"
        >
          {{ 'AUTH.RESET.BUTTON' | translate }}
        </button>
      </div>
      <!--end::Action-->
    </form>
    <!--end::Form-->
  </div>
  <!--end::Signin-->
</div>
